export default __webpack_public_path__ + "static/service-gateway-list-b2bee0e6741da63a111e03e06c30822e.jpg";